module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Bold.dd95809c.ttf";